import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { ThemeType } from '@/modules/types/theme';

export const themeAdapter = createEntityAdapter();

const initialState: ThemeType = themeAdapter.getInitialState({
  isSaved: false,
  isLoaded: false,
  isLoading: false,
  data: null,
});

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    fetch: (state) => {
      state.isLoaded = false;
      state.isLoading = true;
      state.data = null;
    },
    fetchSuccess: (state, action) => {
      state.isLoaded = true;
      state.isLoading = false;
      state.data = action.payload.data.data;
    },
    fetchFailure: (state, action) => {
      state.isLoaded = true;
      state.isLoading = false;
      state.error = action.payload.error;
    },
  },
});

export const { name, actions, reducer } = themeSlice;
